import '@-test-support/reactRedux/connect';
import { Highlight } from '@components/highlight/highlight';
import { useAtomValue } from 'jotai/index';
import React from 'react';
import {
	detailedPricingStartingCostAtom,
	hasStartingCostAtom,
} from '../../../jotai/storefront/detailed-pricing';
import Styles from './highlights.scss';

export const LiteDetailedPricingHighlights = () => {
	const hasStartingCost = useAtomValue(hasStartingCostAtom);
	const startingCost = useAtomValue(detailedPricingStartingCostAtom);

	if (!hasStartingCost) return null;

	return (
		<div className={Styles.highlights}>
			<meta
				itemProp="priceRange"
				content={`${startingCost}+`}
				data-testid="meta-price-range"
			/>
			<Highlight
				iconName="dollar-circle"
				highlightTitle={`${startingCost} starting price`}
			/>
		</div>
	);
};
